import React from "react";
import { AccountWarnings } from "./components/AccountWarnings";
import { AccountInterface, ApiHelper, SubscriptionInterface, UserHelper } from "./helpers";
import { Link } from "react-router-dom";

export const WelcomePage: React.FC = () => {

  const [subscriptions, setSubscriptions] = React.useState<SubscriptionInterface[]>(null);
  const [account, setAccount] = React.useState<AccountInterface>(null);

  const init = () => {
    ApiHelper.get<SubscriptionInterface[]>("/subscriptions")
      .then((data) => { setSubscriptions(data || []); })
      .catch(err => console.error("Failed to load subscriptions:", err));
    ApiHelper.get<AccountInterface>("/accounts/" + UserHelper.currentDepartment.accountId)
      .then((data: AccountInterface) => { setAccount(data); })
      .catch(err => console.error("Failed to load account:", err));
  }

  React.useEffect(init, [])

  const getVideo = () => {
    let result = "https://www.youtube.com/embed/eK2aOHm7TVs" //SignPresenter
    subscriptions?.forEach(s => {
      if (s.feedId === 2) result = "https://www.youtube.com/embed/NXO6yilZbro" //ChiroSign
    })
    if (account?.industry === "Orange") result = "https://www.youtube.com/embed/RP8Wd6wXxGM" //Orange
    return result;
  }

  return (
    <>
      <AccountWarnings />
      <div style={{ marginTop: 40, maxWidth: 800, marginLeft: "auto", marginRight: "auto" }} className="text-center">
        <h1>Welcome to Sign Presenter</h1>
        <p className="lead">Thank you for creating an acount.  The short video below will help you get started.</p>

        <div style={{ position: "relative", paddingBottom: "56.25%", paddingTop: 25, height: 0 }}>
          <iframe title="Welcome Video" style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%" }} width="560" height="315" src={getVideo()} frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
        </div>
        <br />
        <p className="lead">To get started:</p>
        <div className="row">
          <div className="col-lg-4 col-12">
            <div className="inputBox">
              <div className="header">Create Messages</div>
              <div className="content">
                Create <Link to="/messages/">messages</Link> to show on your screen by using our content or uploading your own.
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-12">
            <div className="inputBox">
              <div className="header">Group into Playlists</div>
              <div className="content">
                Group your messages into <Link to="/playlists/">playlists</Link> to make it easier to schedule.
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-12">
            <div className="inputBox">
              <div className="header">Schedule Content</div>
              <div className="content">
                Edit your <Link to="/screens/">screens</Link>' schedules to set when playlists are displayed.
              </div>
            </div>
          </div>
        </div>


        <br />
        <p className="lead">Need help setting up your player?  See additional instructions <a href="https://support.signpresenter.com/topics/maininstructions.html">here</a>.</p>
        <p>Still have questions?  Use the <a href="https://support.signpresenter.com/">support</a> page or contact us via phone at 918-994-2638 or email at <a href="mailto:support@signpresenter.com">support@signpresenter.com</a>.</p>
      </div>
    </>
  );
};